import { createColumnHelper } from "@tanstack/react-table";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import styled from "styled-components";
import RowCheckbox from "components/common/EntityDataTable/RowCheckbox";
import {
  BULK_SELECT_COL_ID,
  CELL_PADDING_VERTICAL,
  CELL_PADDING_HORIZONTAL
} from "components/common/EntityDataTable/Constants";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
const HeaderCheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  padding: ${CELL_PADDING_VERTICAL}px ${CELL_PADDING_HORIZONTAL}px;
`;
const BulkSelectHeader = ({ table }) => {
  var _a, _b;
  const { t } = useTranslation("common");
  const { isSomeRowsSelected, isAllRowsSelected } = useSelectedEntities();
  const title = isAllRowsSelected ? t("entity_table.deselect_all") : t("entity_table.select_all");
  return /* @__PURE__ */ React.createElement(HeaderCheckboxContainer, null, /* @__PURE__ */ React.createElement(
    RowCheckbox,
    {
      onChange: table.getToggleAllRowsSelectedHandler(),
      checked: isAllRowsSelected,
      indeterminate: isSomeRowsSelected,
      title,
      disabled: !((_b = (_a = table.options) == null ? void 0 : _a.data) == null ? void 0 : _b.length),
      "aria-label": title
    }
  ));
};
const BulkSelectCell = ({ row }) => {
  const { t } = useTranslation("common");
  const { selectedEntities } = useSelectedEntities();
  return /* @__PURE__ */ React.createElement(
    RowCheckbox,
    {
      onChange: row.getToggleSelectedHandler(),
      title: row.getIsSelected() ? t("entity_table.deselect_entity") : t("entity_table.select_entity"),
      checked: selectedEntities.includes(row.id),
      disabled: !row.getCanSelect()
    }
  );
};
const useBulkSelectColumnDefinition = (displayBulkSelectCol, colWidth) => {
  const columnHelper = createColumnHelper();
  return useMemo(
    () => displayBulkSelectCol ? columnHelper.display({
      id: BULK_SELECT_COL_ID,
      size: colWidth,
      header: BulkSelectHeader,
      enableHiding: false,
      cell: BulkSelectCell,
      enableResizing: false
    }) : null,
    [displayBulkSelectCol, columnHelper, colWidth]
  );
};
export default useBulkSelectColumnDefinition;
